// frontend/src/components/common/StrategyControls.js
export function strategyStatus(strategy, isManual = true) {
  if (!strategy) return '전략 없음';
  if (strategy.busy) return '주문 처리·상태 확인 중';
  if (strategy.is_open)
    return strategy.is_active ? '보유 중' : '보유 중 · 진입 OFF';
  if (strategy.exit_reason === 'admin_manual_off') return '비활성';
  if (strategy.is_active && isManual && !strategy.manual_approved)
    return '관리자 선택 필요';
  if (strategy.is_active) return '진입 대기';
  return `종료·차단${strategy.exit_reason ? ` (${strategy.exit_reason})` : ''}`;
}

export default function StrategyControls({
  row,
  control,
  pendingId,
  onAction,
}) {
  if (!control?.can_manage) return null;
  const strategy = row.strategy;
  const busy = pendingId !== null || strategy?.busy;
  const inSession =
    Date.parse(row.timestamp_korean_box) >= Date.parse(control.session_start) &&
    Date.parse(row.timestamp_korean_box) < Date.parse(control.session_end);
  const alreadyOn =
    row.most_line && strategy?.is_active && strategy?.manual_approved;
  const activationOpen =
    control.activation_open &&
    Date.now() < Date.parse(control.session_end) - 60000;
  const buttonClass = 'px-2 py-1 border rounded disabled:opacity-40';
  return (
    <div
      className='flex gap-2 justify-center whitespace-nowrap'
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type='button'
        className={buttonClass}
        disabled={
          busy ||
          alreadyOn ||
          strategy?.is_open ||
          !inSession ||
          !activationOpen
        }
        onClick={() => onAction(row, 'on')}
      >
        활성화
      </button>
      <button
        type='button'
        className={buttonClass}
        disabled={busy || !strategy || (!row.most_line && !strategy.is_active)}
        onClick={() => onAction(row, 'off')}
      >
        비활성화
      </button>
      <button
        type='button'
        className={buttonClass}
        title='비활성이며 보유 포지션·처리 중인 주문이 없는 전략과 주문·체결 이력을 삭제합니다. 원본 라인은 유지됩니다.'
        disabled={busy || !strategy?.can_delete}
        onClick={() => onAction(row, 'delete')}
      >
        전략 삭제
      </button>
    </div>
  );
}
